import Boards from './BoardsPage';

export default Boards;
